import { useId } from 'react'

import { InfoIcon } from '../Icons'
import { Tooltip } from '../Tooltip'
import { TabItemContainer } from './styles'

type Props = {
  showInfo?: boolean
  tooltipMessage?: string
  label: string
}

export const TabItem = ({
  showInfo = false,
  tooltipMessage = '',
  label,
}: Props) => {
  const id = useId()

  return (
    <TabItemContainer>
      <div className="tab-item">
        {label}
        {showInfo && (
          <div className="tooltip">
            <Tooltip id={id} text={tooltipMessage}>
              <InfoIcon color="red" size={18} />
            </Tooltip>
          </div>
        )}
      </div>
    </TabItemContainer>
  )
}
